module.exports = __webpack_public_path__ + "static/media/spirit_fruit_logo_text.d0e62a07.png";